<template>
  <div class='flex1'>
    <div class='userContext'>
      <div class='col6-left col6-mdBreak flex1 textAlignRight'>
        <p class='marginB0'>Viewing as: <b>{{ _.get(userCurrentContext, 'label', 'Unknown') }}</b></p>
      </div>
      <div class='col6-right col6-mdBreak flex1 textAlignLeft'>
        <b-button type="button" variant="primary" @click="toggleModal" class='largeBtn marginB0'>Change Organization</b-button>
      </div>
    </div>

    <b-modal
        size="lg"
        centered

        title="Change Group/Organization"
        header-bg-variant="success"
        header-text-variant="light"

        :visible="showModal"
        @hide="toggleModal"

        ok-title="Save"
        @ok="umogChangeHandler"
      >
       <template #modal-header-close>
          <h4>X</h4>
        </template>

        <b-form>
          <b-form-group>
            <b-form-select
              :options="userGroupOrganizationOptions"
              v-model="userGroupOrganization"
              placeholder="Type to Search"
            >
            <template slot="first">
              <option :value="null" disabled>-- Please select a group --</option>
            </template>

            </b-form-select>
          </b-form-group>
        </b-form>
      </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'usercontext',
  data: function () {
    return {
      showModal: false,
      userContext: false,
      eventListner: false,
      userGroupOrganization: {}
    }
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext',
      userContextOptions: 'userContextOptions',
      userFromStore: 'getViewUser'
    }),
    user: {
      get () {
        return this.userFromStore
      },
      set (newUser) {
        return newUser
      }
    },
    userGroupOrganizationOptions: function () {
      const iteratee = this.userContextOptions

      let options = iteratee.reduce((acc, combo) => {
        const option = {
          text: combo.label,
          value: {
            ...combo
          }
        }
        acc.push(option)
        return acc
      }, [])

      options.sort((a, b) => {
        return a.text < b.text ? -1 : 1
      })

      return options
    }
  },
  watch: {
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.userGroupOrganization = newValue
      }
    },
    userContextOptions: function (newValue) {
      if (newValue) {
        this.userContextOptions = newValue
      }
    },
    user: function (newValue) {
      if (newValue) {
        this.user = newValue
      }
    }
  },
  methods: {
    toggleModal () {
      if (this.eventListner) {
        let userId = this.userGroupOrganization.userMember.muser
        this.$store.dispatch('resetUser', userId)
        this.eventListner = false
        this.user = this.$store.state.getViewUser
      }
      this.showModal = !this.showModal
    },
    umogChangeHandler (e) {
      const ugos = this.userContextOptions
      const next = this.userGroupOrganization

      if (!_.isEmpty(next)) {
        let ugo = ugos.find((o) => next.organization.id === o.organization.id && next.group.id === o.group.id)
        if (ugo) {
          this.$store.commit('SET_USER_CONTEXT', ugo)
        }
      }
    }
  },
  created () {
    if (this.userCurrentContext) {
      this.userGroupOrganization = this.userCurrentContext
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Header/UserContext.vue